import React from 'react'
import PropTypes from 'prop-types'
import { QuantityComponentRaw } from 'components/common/Quantity/Quantity'
import styled from 'styled-components'
import Media from 'components/common/Media'

const ProductQuantityInput = ({ quantity, inputId, increaseHandler, decreaseHandler, disabled, className }) =>
  <CustomQuantityComponent
    id={ inputId }
    small
    value={ quantity }
    disabled={ disabled }
    increaseHandler={ increaseHandler }
    decreaseHandler={ decreaseHandler }
    className={ className } />

ProductQuantityInput.propTypes = {
  className: PropTypes.string,
  decreaseHandler: PropTypes.func,
  disabled: PropTypes.bool,
  increaseHandler: PropTypes.func,
  inputId: PropTypes.string,
  quantity: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
}

export default ProductQuantityInput

const CustomQuantityComponent = styled(QuantityComponentRaw)`
  ${Media.mobile`
    display:inline-flex;
  `}
`
